<div class="page-main-header" [class.open]="open">
  <div class="main-header-right row">
    <div class="main-header-left d-lg-none">
      <div class="logo-wrapper"><a [routerLink]="'/'"><img class="blur-up lazyloaded"
            src="../../../../assets/images/anre-logo-icon.png" alt=""></a></div>
    </div>
    <div class="mobile-sidebar">
      <div class="media-body text-right switch-sm">
        <label class="switch">
          <a>
            <app-feather-icons id="sidebar-toggle" [icon]="'align-left'" (click)="collapseSidebar()">
            </app-feather-icons>
          </a>
        </label>
        <ng-container *ngIf="!isMobile">
          <span class="h5 bold ml-5">{{roleName}}</span>
          <ng-container *ngIf="validated">
            <a style="font-size: 24px; padding-left:10px;"><i class="fa fa-check-circle"
                                                              style="font-size: 24px; color: green"
                                                              title="Cont validat"></i></a>
          </ng-container>
          <ng-container *ngIf="!hideManual">
            <a style="font-size: 24px; padding:16px;" href="{{helpUrl}}"><i class="fa fa-cloud-download"> <span
              style="font-size: 12px; padding:10px;" class=" bold ">Descarca manual</span></i></a>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="nav-right col">
      <div class="mb-0" style="text-align: right">{{userEmail}}</div>
      <div class="d-lg-none mobile-toggle pull-right" (click)="openMobileNav()">
        <app-feather-icons [icon]="'more-horizontal'"></app-feather-icons>
      </div>

      <ul class="nav-menus" [ngClass]="{'open' : openNav}">
        <li *ngIf="!isMobile">
          <a href="javascript:void(0)" class="text-dark" toggleFullscreen>
            <app-feather-icons [icon]="'maximize-2'"></app-feather-icons>
          </a>
        </li>

        <ng-container>
          <li>
            <div class="media align-items-center" (click)="openEmailModal()"><img class=" align-self-center pull-right
          img-50" src="/assets/images/email.png" alt="header-user">
            </div>
          </li>
        </ng-container>

        <ng-container *ngIf="isMobile">
          <li class="text-align-left">
            <span class="bold" [class]="{'h5' : !isMobile, 'h7' : isMobile}">{{roleName}}</span>
          </li>
          <ng-container *ngIf="validated">
            <li>
              <a style="font-size: 24px; padding-left:10px;"><i class="fa fa-check-circle"
                                                                style="font-size: 24px; color: green"
                                                                title="Cont validat"></i></a>
            </li>
          </ng-container>
          <li id="mobile-download-link" class="no-padding width-auto margin-left-auto no-border">
            <a style="font-size: 24px; padding:16px;" href="{{helpUrl}}"><i class="fa fa-cloud-download"> <span
              style="font-size: 12px; padding:10px;" class=" bold ">Descarca manual</span></i></a>
          </li>
        </ng-container>

        <li id="person-icon" class="onhover-dropdown">
          <div class="media align-items-center">
            <img class="align-self-center pull-right img-50 rounded-circle" src="/assets/images/man.png"
              alt="header-user">
          </div>
          <ul class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
            <li *ngIf="roleName !== 'ANRE'">
              <a [routerLink]="identificationDataRouterLink">
                <app-feather-icons [icon]="'user'"></app-feather-icons>
                Date identificare
              </a>
            </li>
            <li>
              <a (click)="logout()">
                <app-feather-icons [icon]="'log-out'"></app-feather-icons>
                Deconectare
              </a>
            </li>
          </ul>
        </li>
      </ul>

    </div>
  </div>
</div>
